module.exports = __webpack_public_path__ + "media/images/icons/flags/LI-0eab1ffd86a27cc7dbab600c47de67d8.svg";